import React, { useState, useEffect } from "react"
import { useTheme } from '~/contexts/ThemeContext'
import { usePdp } from '~/contexts/PdpContext'
import { jnstyls } from '~/utils/helpers'

import IconClose from '~/components/icons/close'
import PickupStores from '~/components/pdp/pickup-stores'

import { aria_btn, bubb_btn, dotcheck_label, dotcheck } from "~/styles/app.module.scss"
import * as styles from "~/styles/pdp/pickup.module.scss"


const ShipPickup = ({ bis=false }) => {
  const { pdpVariant, locate, setLocate, isSHM } = useTheme()
  const { product, variants, blockPickup, isPickup, onSwitchDelivery, anyStores, nearInstock } = usePdp()
  const { is_gift } = product

  const [allowPickup, setAllowPickup] = useState(false)

  const checkThisProd = () => {
    return variants.find(x => x.id === pdpVariant?.id)
  }

  const checkShip = () => {
    const wh_combo = pdpVariant && pdpVariant.inv && (!!pdpVariant?.inv?.DW || !!pdpVariant?.inv['BL - Ecommerce'])
    const ship_avail = !isSHM ? !!pdpVariant.ship : wh_combo
    return (pdpVariant && checkThisProd()) && !(pdpVariant.available && ship_avail)
  }

  const checkPickup = () => {
    setAllowPickup(pdpVariant?.available && !!pdpVariant?.pickup && !blockPickup && anyStores?.length > 0)
  }

  const setIntl = (state) => {
    setLocate({
      ...locate,
      shipIntl: state
    })
  }

  useEffect(() => {
    if (is_gift) {
      setAllowPickup(false)
      return
    }
    if (!checkThisProd()) return
    checkPickup()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pdpVariant, blockPickup, anyStores])

  useEffect(() => {
    checkPickup()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  

  return (
    <div className={styles.wrap}>
      <div className={styles.opt}>
        <label 
          className={jnstyls([styles.opt_label, dotcheck_label])} 
          disabled={ checkShip() ? 'disabled' : undefined}
          type={'button'}
          aria-current={(!isPickup).toString()}
          opt-ship=''
        >
          <input 
            type='radio' 
            value='ship'
            disabled={checkShip() ? 'disabled' : undefined}
            name={`ship_type_${product.mid}`}
            checked={!isPickup}
            onChange={(e)=>{ onSwitchDelivery('ship')}}
          />
          <div className={dotcheck}></div>
          <span>Delivery</span>
        </label>
      </div>
      <div className={styles.opt}>
        <label 
          className={jnstyls([styles.opt_label, dotcheck_label])}
          disabled={(!(pdpVariant && checkThisProd()) || allowPickup ) ? undefined : 'disabled'}
          aria-current={(isPickup).toString()}
          type={'button'}
          opt-pickup=''
        >
          <input 
            type='radio' 
            value='pickup'
            disabled={(!(pdpVariant && checkThisProd()) || allowPickup ) ? undefined : 'disabled'}
            name={`ship_type_${product.mid}`}
            checked={isPickup}
            onChange={(e)=>{ onSwitchDelivery('pickup')}}
          />
          <div className={dotcheck}></div>
          <span>Pick-up</span>
          {(checkThisProd() && pdpVariant?.pickup && !isPickup && nearInstock.length > 0) && (
            <span className={styles.pick_stock}>In-Stock Near You</span>
          )}
        </label>

        
        <div className={styles.pickup}>
          {(isPickup && (!pdpVariant || !checkThisProd()) ) && (
            <>Select size to view store availability</>
          )}
          {(isPickup && (pdpVariant && checkThisProd()) && !blockPickup) && (
            <PickupStores />
          )}
        </div>
      </div>

      {(!!locate && !isPickup && (locate?.shipIntl || locate?.country !== 'US')) && (
        <div className={jnstyls([styles.intl, styles.intl_new])}>
          {(locate?.shipIntl && locate?.currStores.length < 1) && (
            <button 
              className={jnstyls([aria_btn, bubb_btn, styles.bubb_btn])} 
              aria-pressed={'true'}
              aria-label={'Ships internationally'}
              onClick={(e)=> setIntl(false)}
              type={'button'}
            >
              SHIP INTL
              <IconClose icon_classes={''} />
            </button>
          )}
          {(!locate?.shipIntl && locate?.country !== 'US') && (
            <button 
              className={jnstyls([aria_btn, bubb_btn, styles.intl_off])} 
              aria-pressed={'true'}
              aria-label={'Ships internationally'}
              onClick={(e)=> setIntl(true)}
              type={'button'}
            >
              Show Ship Intl
            </button>
          )}
        </div>
      )}

    </div>
  )
}

export default ShipPickup


